import { useEffect, useRef, useState } from "react";
import UserInfo from "components/UserInfo";
import userProfile from "services/user.profile";
import profilePhoto from "assets/images/profile_photo.svg";
import styles from "./Table.module.scss";

const Table = ({
  data,
  photos,
  setCurrentScreen,
  setMemberDetails,
  sortColumn,
}) => {
  const ref = useRef();
  const [activeColumn, setActiveColumn] = useState("first_name");

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--thead-height",
        `${ref.current?.offsetHeight}px`
      );
    }
  }

  useEffect(() => {
    setHeaderHeight();
  }, [data]);

  const handleClick = (e, id, photoUrl) => {
    e.preventDefault();

    userProfile.getProfileMemberById(id).then(
      (response) => {
        setMemberDetails(Object.assign(response?.data, { photo: photoUrl }));
        setCurrentScreen("edit");
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setMemberDetails(_content);
      }
    );
  };

  const handleSort = (columnName) => {
    sortColumn(columnName);
    setActiveColumn(columnName);
  };

  return (
    data && (
      <div className={styles.wrapper}>
        <table className={styles.content}>
          <thead className={styles.header} ref={ref}>
            <tr className={styles.row}>
              <th
                onClick={() => handleSort("first_name")}
                className={activeColumn === "first_name" ? styles.active : ""}
              >
                Name
              </th>
              <th>Email</th>
              {/* Hidden temporarily
              <th>Team</th>
              <th
                onClick={() => handleSort("schedule")}
                className={activeColumn === "schedule" ? styles.active : ""}
              >
                Schedule
              </th>
              <th>BambooHR</th>
              <th>Smart Tel Id</th>
              <th>Smart Tel Ext</th>
              */}
              <th>Last Login</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody className={styles.body}>
            {data?.map((item, index) => {
              const photoUrl = photos.get(
                item?.first_name + " " + item?.last_name
              );
              return (
                <tr
                  key={item?.id ?? index}
                  onClick={(e) => handleClick(e, item.id, photoUrl)}
                >
                  <td>
                    <UserInfo
                      src={photoUrl ?? profilePhoto}
                      name={item?.first_name + " " + item?.last_name}
                    />
                  </td>
                  <td>{item?.email ?? "-"}</td>
                  {/* Hidden temporarily
                  <td>{item?.team ?? "-"}</td>
                  <td>{item?.schedule ?? "-"}</td>
                  <td>{item?.bamboo_id ?? "-"}</td>
                  <td>{item?.usko_mysmart_tel_id ?? "-"}</td>
                  <td>{item?.extension ?? "-"}</td>
                  */}
                  <td>{item?.last_login ?? "-"}</td>
                  <td>{item?.is_active ? "Active" : "Inactive"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )
  );
};

export default Table;
